import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background: #f4f4f4;
  min-height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  padding: 10px 50px;
  box-sizing: border-box;
  left: 0;
  right: 0;
`
const Title = styled.div`
  justify-self: center;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0px;
`
const CloseButton = styled.div`
  color: #979797 !important;
  justify-self: center;
  align-self: center;
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 7px;
  font-size: 30px;
  &:hover {
    cursor: pointer;
    color: black;
    text-decoration: none;
  }
`
const noop = () => {}
const ModalHeader = ({ title, onClose = noop }) => {
  return (
    <Container>
      <Title>
        {title}
      </Title>
      <CloseButton id="smart_rate_close" onClick={onClose}>
        &times;
      </CloseButton>
    </Container>
  )
}

ModalHeader.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired
}

export default ModalHeader
